<script setup>
import { computed } from 'vue';
import { cva } from 'class-variance-authority';

import LocaleSwitch from '@/components/legal/LocaleSwitch.vue';

const props = defineProps({
  brand: { type: String, default: 'Deenly' },
  backHref: { type: String, default: '/' },
  backLabel: { type: String, required: true },
});

const wrapClass = computed(() =>
  cva(
    'fixed top-6 left-1/2 -translate-x-1/2 w-full max-w-3xl z-40 px-6 transition-all animate-slide-up',
    { variants: { intent: { default: '' } } }
  )({ intent: 'default' })
);
</script>

<template>
  <header :class="wrapClass">
    <div
      class="glass-nav rounded-2xl border border-[#1c4848]/5 h-16 px-6 shadow-[0_8px_30px_rgb(28,72,72,0.04)]"
    >
      <!-- 3-col grid ensures true visual centering -->
      <div class="h-full grid grid-cols-[1fr_auto_1fr] items-center">
        <div class="min-w-0 flex items-center gap-3 justify-start">
          <a :href="props.backHref" class="text-sm font-medium text-[#1c4848]/50 hover:text-[#1c4848] transition-colors duration-300">
            ← {{ props.backLabel }}
          </a>
        </div>

        <a href="/" class="flex items-center justify-center gap-3 group justify-self-center">
          <div
            class="w-8 h-8 rounded-lg bg-gradient-to-br from-[#1c4848] to-[#112a2a] text-[#ecd79f] flex items-center justify-center shadow-md group-hover:scale-105 transition-transform duration-300 ring-1 ring-white/10 overflow-hidden"
          >
            <img src="@/assets/logo.svg" :alt="props.brand" class="w-5 h-5" />
          </div>
          <span class="text-lg font-serif text-[#1c4848] font-medium tracking-tight">
            {{ props.brand }}
          </span>
        </a>

        <div class="min-w-0 flex items-center justify-end">
          <div class="hidden sm:block">
            <LocaleSwitch :showLabel="false" variant="pills" />
          </div>
          <div class="sm:hidden">
            <LocaleSwitch :showLabel="false" variant="select" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

